// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { GemsSelectedRangeFragmentDoc } from './selectedRange.fragment.generated';
export const GemsSelectedFiltersFragmentDoc = gql`
    fragment GemsSelectedFilters on GemsApi_SelectedStoneFilters {
  category
  crystal
  colour
  grade
  shape
  clarity
  fluorescence
  symmetry
  cut
  polish
  shippingFrom
  originCountry
  notColour
  notClarity
  notSymmetry
  lab
  collection
  hasPhoto
  isCanadaMark
  isDtlReport
  isScsReport
  withVideo
  withOriginCountry
  isStock
  isRtg
  price {
    ...GemsSelectedRange
  }
  costPrice {
    ...GemsSelectedRange
  }
  weight {
    ...GemsSelectedRange
  }
  depthPercent {
    ...GemsSelectedRange
  }
  tablePercent {
    ...GemsSelectedRange
  }
  ratio {
    ...GemsSelectedRange
  }
  length {
    ...GemsSelectedRange
  }
  width {
    ...GemsSelectedRange
  }
  depth {
    ...GemsSelectedRange
  }
  sorting {
    __typename
    field
    direction
  }
  priceIndex
}
    ${GemsSelectedRangeFragmentDoc}`;